
/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { Button } from "../../../Components";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Check, Error, Email, Security, WhatsApp } from "../../../Assets/icons";
// import { LoginSecurity } from "../../../Assets/icons";
// import { LogOutIcon } from "../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Title, TitleContainer, ImageIcon, Icon, SecurityContainer } from "./styles";

/* 🔧 UTILS */
import { displayBrPhone } from "../../../util/phone";

const SecurityTab = ({ userId, Services, usuario, setUsuario }) => {
    const { t } = useTranslation();
    const { isOpen, currentStep } = useTour();

    const [cooldown, setCooldown] = useState(false);

    const handleConfirmEmail = async() => {
        if (cooldown) return;

        setCooldown(true);
        await Services.current.sendEmailConfirmation();

        setTimeout(() => {
        setCooldown(false);
        }, 4000);
    }

    // Identifica qual o sistema operacional
    // const getOperatingSystem = (userAgent) => {
    //     if (userAgent.includes('Windows')) return 'Windows';
    //     if (userAgent.includes('Macintosh')) return 'macOS';
    //     if (userAgent.includes('Linux')) return 'Linux';
    //     if (userAgent.includes('Android')) return 'Android';
    //     if (userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'iOS';
    //     return 'Unknown';
    // }

    return(
        <SecurityContainer className="data-container">
            <TitleContainer>
                <Title>{t("administrative.sub-items.employees.view.security-settings.title")}</Title>
                <p className="subtitle">{t("administrative.sub-items.employees.view.security-settings.subtitle")}</p>
            </TitleContainer>
            {/* Logins ativos desativado temporariamente: os tokens não estão sendo gravados e a lista sempre vem vazia */}
            {/* <div className="active-login">
                <h2>{t("administrative.sub-items.employees.view.security-settings.active-logins.title")}</h2>
                <ul>
                    {usuario?.tokens?.map((token, index) => (
                        <li key={index}>
                            <div className="session-info">
                                <p className="info-line">
                                    <span className="label">{t("administrative.sub-items.employees.view.security-settings.active-logins.first-access")}</span>
                                    <span className="value">{t("date.date-hour", {date: new Date(token?.created_at), format: "dayAndHour"})}</span>
                                </p>
                                <p className="info-line">
                                    <span className="label">{t("administrative.sub-items.employees.view.security-settings.active-logins.last-access")}</span>
                                    <span className="value">{t("date.date-hour", {date: new Date(token?.last_used_at), format: "dayAndHour"})}</span>
                                </p>
                                <p className="info-line">
                                    <span className="label">{t("administrative.sub-items.employees.view.security-settings.active-logins.system")}</span>
                                    <span className="value">{getOperatingSystem(token?.name)}</span>
                                </p>
                            </div>
                            <Button
                                text={t("buttons.logout")}
                                onClick={() => {
                                    Services.current.invalidateToken(token.id);
                                    setUsuario({...usuario, tokens: usuario?.tokens?.filter((user_token) => user_token.id !== token.id)});
                                }}
                                icon={<ImageIcon className={"icon"} src={LogOutIcon}/>}
                                padding={"12px"}
                            />
                        </li>
                    ))}
                </ul>
                <Button text={t("buttons.activity-history")} color={'disabled'} disabled={true} onClick={() => console.log("desativado")} icon={<ImageIcon src={LoginSecurity} fill={'gray'}/>} float={"right"} />
            </div> */}
            <div className="status">
                <h2>Status</h2>
                <div>
                    <span>
                        <Icon src={usuario?.contacts?.whatsapp_verified ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.status.whatsapp")}
                    </span>
                    <span>
                        <Icon src={usuario?.contacts?.email_verified ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.status.email")}
                    </span>
                    <span>
                        <Icon src={usuario?.security?.has2fa ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.status.2fa")}
                    </span>  
                </div>
            </div>
            <div className="inputs-container">
                <div className="card" id="email-card">
                    <h3>
                        <Icon src={usuario?.contacts?.email_verified ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.cards.email")}
                    </h3>
                    <p>{usuario?.contacts?.email}</p>
                    <Button 
                    text={t("buttons.confirm-email")} 
                    width={'100%'} 
                    disabled={cooldown || (userId === store.getState().userReducer.user.id && usuario?.contacts?.email_verified === true) || (isOpen && currentStep === 0)} 
                    onClick={() => handleConfirmEmail()} 
                    icon={<ImageIcon src={Email}/>}/>
                </div>
                <div className="card" id="two-factor-auth-card">
                    <h3>
                        <Icon src={usuario?.security?.has2fa ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.cards.2fa.title")}
                    </h3>
                    <p>{usuario?.security?.has2fa ? t("administrative.sub-items.employees.view.security-settings.cards.2fa.content.authenticated") :  t("administrative.sub-items.employees.view.security-settings.cards.2fa.content.unauthenticated")}</p>
                    <Button 
                    text={t("buttons.2fa")} 
                    width={'100%'} 
                    disabled={isOpen && currentStep === 1} 
                    onClick={() => store.dispatch(changeModal('f2aModal'))} 
                    icon={<ImageIcon src={Security} />}/>
                </div>
                    <div className="card">
                    <h3>
                        <Icon src={usuario?.contacts?.whatsapp_verified ? Check : Error} />
                        {t("administrative.sub-items.employees.view.security-settings.cards.whatsapp")}
                    </h3>
                    <p>{displayBrPhone(usuario?.contacts?.whatsapp, true)}</p>
                    <Button 
                    text={t("buttons.confirm-whatsapp")} 
                    width={'100%'} 
                    disabled={usuario?.contacts?.whatsapp_verified === true} 
                    onClick={() => {
                        Services.current.sendWhatsappCode();
                        store.dispatch(changeModal('whatsappModal'));
                    }} 
                    icon={<ImageIcon src={WhatsApp} />}/>
                </div>
            </div>
        </SecurityContainer>
    );
}

export default SecurityTab;